module.exports = __webpack_public_path__ + "img/female.86db4b30.svg";